<template>
  <div style="padding-bottom: 20px;">
    <div class="headerCircle">
      <h3># 圈子列表</h3>

      <div style="display: flex; align-items: center;">
        <el-button v-if="!addCard" size="small" @click="newFoundCircle" >新建圈子</el-button>
        <div style="margin-left: 40px;">
          <el-input placeholder="请根据搜索类型输入内容" v-model="searchVal" class="input-with-select">
            <el-select v-model="searchType" slot="prepend" style="width: 120px;background: #fff;" placeholder="请选择搜索类型">
              <el-option label="广场id" value="1"></el-option>
              <el-option label="圈子名称" value="2"></el-option>
              <el-option label="圈子id" value="3"></el-option>
            </el-select>
            <el-button slot="append" icon="el-icon-search" style="width: 60px;" @click="searchCircleCli"></el-button>
          </el-input>
        </div>
      </div>
    </div>

    <el-tabs v-model="tabCount" @tab-click="tabsHandleFn">
      <el-tab-pane label="全部" name="0"></el-tab-pane>
      <el-tab-pane label="待审核" name="1"></el-tab-pane>
      <el-tab-pane label="已通过" name="2"></el-tab-pane>
      <el-tab-pane label="已拒绝" name="3"></el-tab-pane>
      <el-tab-pane label="被举报下架" name="4"></el-tab-pane>
    </el-tabs>
    <el-table :data="tableData" row-key="circleId" style="width: 81vw" :row-class-name="tableRowClassName"
      :expand-row-keys="expandKey" @expand-change="expandChange">
      <el-table-column type="index" label="排序" width="50" align="center">
      </el-table-column>
      <el-table-column prop="squareId" label="广场id" width="80" align="center">
      </el-table-column>
      <el-table-column prop="circleId" label="圈子id" width="80" align="center">
      </el-table-column>
      <el-table-column label="圈子图标" align="center">
        <template slot-scope="scope">
          <el-image style="width: 40px; height: 40px" :src="scope.row.coverLogo" fit="cover"></el-image>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="圈子名称" align="center">
      </el-table-column>
      <el-table-column label="圈子状态" align="center">
        <template slot-scope="tableData">
          {{ tableData.row.circleState == 0 ? '正常访问' : '暂停访问' }}
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" align="center" width="160">
      </el-table-column>
      <el-table-column label="审核状态" align="center">
        <template slot-scope="tableData">
          <el-tag :type="tableData.row.auditStatus == 0 || tableData.row.auditStatus == null ? 'info' : tableData.row.auditStatus == 1 ? 'success' : tableData.row.auditStatus == 2 ? 'danger' : 'danger'">
            {{ tableData.row.auditStatus == 0 || tableData.row.auditStatus == null ? '待审核' : tableData.row.auditStatus == 1 ? '已通过' : tableData.row.auditStatus == 2 ? '已拒绝' : '被举报下架' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="releaseGrade" label="发帖等级限制" align="center">
        <template slot-scope="tableData">
          {{ tableData.row.releaseGrade + ' 级' }}
        </template>
      </el-table-column>
      <el-table-column prop="browseGrade" label="浏览等级限制" align="center">
        <template slot-scope="tableData">
          {{ tableData.row.browseGrade + ' 级' }}
        </template>
      </el-table-column>
      <el-table-column prop="browsePermissions" label="圈子浏览权限" align="center">
        <template slot-scope="tableData">
          {{ tableData.row.browsePermissions === '0' ? '所有人可见' : tableData.row.browsePermissions === '1' ? '会员用户可见' :
            '审核加入可见' }}
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center" fixed="right" v-if="addCard">
        <template slot-scope="scope">
          <el-button size="small" type="primary" plain @click="selectCircle(scope.row)">选择</el-button>
        </template>
      </el-table-column>

      <el-table-column label="变更状态" align="center" fixed="right" v-if="!addCard">
        <template slot-scope="scope">
          <el-button size="small" type="primary" plain @click="editCircleStatus(scope.row)">
            操作<i class="el-icon-arrow-right el-icon--right"></i>
          </el-button>
        </template>
      </el-table-column>

      <el-table-column label="操作" fixed="right" type="expand" v-if="!addCard">
        <template slot-scope="scope">
          <div style="width: 100%;display: flex;align-items: center;">
            <div class="el-form-item-edit">
              <el-button size="small" @click="controlFn(scope.row, '圈子管理')">圈子管理团队</el-button>
            </div>
            <div class="el-form-item-edit">
              <el-button size="small" @click="controlFn(scope.row, '加入审核')">加入审核列表</el-button>
            </div>
            <div class="el-form-item-edit">
              <el-button size="small" @click="controlFn(scope.row, '查看帖子')">查看帖子</el-button>
            </div>
            <div class="el-form-item-edit">
              <el-button size="small" @click="controlFn(scope.row, '禁言列表')">禁言列表</el-button>
            </div>
            <div class="el-form-item-edit">
              <el-button size="small" @click="handleClick(scope.row)">编辑圈子</el-button>
            </div>
            <div class="el-form-item-edit">
              <el-button size="small" type="warning" plain @click="openExitSwitch(scope.row)">退出申请设置</el-button>
            </div>
            <div class="el-form-item-edit">
              <el-button size="small" @click.native.prevent="deleteRow(scope.row)">删除圈子</el-button>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="block" style="text-align: end;margin-top: 10px;">
      <el-pagination @size-change="handleSizeChange" @current-change="pageTurning"
        :current-page.sync="searchForm.pageNum" :page-sizes="[10, 20, 30, 50]" :page-size="searchForm.pageSize"
        layout="total, sizes, prev, pager, next" :total="total">
      </el-pagination>
    </div>

    <el-dialog title="圈子管理团队" :visible.sync="controlShow" append-to-body width="75%">
      <div v-if="controlShow">
        <CircleAdmin />
      </div>
    </el-dialog>

    <el-dialog :visible.sync="banSpeakShow" append-to-body width="80%">
      <div v-if="banSpeakShow">
        <banSpeak :circleId="nowCircleId"></banSpeak>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="cardShow" :center="true" append-to-body width="90%">
      <div v-if="cardShow">
        <cardList :circleIdVal="nowCircleId.circleId"></cardList>
      </div>

    </el-dialog>

    <el-dialog title="加入审核列表" :visible.sync="followShow" append-to-body width="60%">
      <div v-if="followShow">
        <checkCircle :circleId="nowCircleId.circleId"></checkCircle>
      </div>
    </el-dialog>

    <circleAudit ref="refCircleAudit" :circleData="nowCircleData" @updataCircle="getList()" />

    <el-dialog title="圈子职位退出申请设置" :visible.sync="exitSwitchVisible" append-to-body
      width="600px" top="16vh" custom-class="exit-switch-dialog">
      <div class="exit-switch-content">
        <div class="exit-switch-row">
          <div class="exit-switch-info">
            <div class="exit-switch-title">圈主辞职申请</div>
            <div class="exit-switch-desc">允许圈主在小程序提交辞职理由和证明图片</div>
          </div>
          <el-switch v-model="exitSwitchForm.ownerResignSwitch" active-text="开启" inactive-text="关闭" />
        </div>
        <div class="exit-switch-row">
          <div class="exit-switch-info">
            <div class="exit-switch-title">管理员退出申请</div>
            <div class="exit-switch-desc">允许圈子管理员在小程序提交退出申请</div>
          </div>
          <el-switch v-model="exitSwitchForm.adminExitSwitch" active-text="开启" inactive-text="关闭" />
        </div>
        <div class="exit-switch-tip">
          <i class="el-icon-info"></i>
          关闭后小程序不能再提交对应申请，已经提交的待审核申请仍可继续审核。
        </div>
      </div>
      <span slot="footer">
        <el-button @click="exitSwitchVisible = false">取消</el-button>
        <el-button type="primary" :loading="exitSwitchSaving" @click="saveExitSwitch">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { GetcircleListApi, DeleteCircleApi } from '@/api/user.js'
import { getSquareCircleApi, updateCircleExitSwitchApi } from "@/api/circle.js";
import CircleAdmin from '@/components/circleComp/circleAdmin'
import checkCircle from '@/components/circleComp/checkCircle'
import cardList from '@/views/content'
import banSpeak from '@/views/circle/banSpeak'
import circleAudit from '@/components/circleComp/circleAudit'

export default {
  name: 'inTerior',
  components: { CircleAdmin, checkCircle, cardList, banSpeak, circleAudit },
  data() {
    return {
      searchForm: { pageNum: 1, pageSize: 10, circleId: '', name: '', auditStatus: '' },
      total: 0,
      tableData: [],
      activeNames: ['1'],
      searchCircle: '',
      total_pages: 0,
      controlShow: false,
      nowCircleId: {},
      expandKey: [],
      followShow: false,
      cardShow: false,
      banSpeakShow: false,
      nowCircleData: {},
      searchType: '2',
      tabCount: 0,
      searchVal: '',
      exitSwitchVisible: false,
      exitSwitchSaving: false,
      exitSwitchForm: { circleId: '', ownerResignSwitch: true, adminExitSwitch: true }
    }
  },
  props: {
    squareId: {
      type: String,
      default: ''
    },
    addCard: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    if (this.squareId) {
      this.checkSuqareFn(this.squareId)
    } else {
      this.getList();
    }
  },
  methods: {
    openExitSwitch(row) {
      this.exitSwitchForm = {
        circleId: row.circleId,
        ownerResignSwitch: row.ownerResignSwitch !== false,
        adminExitSwitch: row.adminExitSwitch !== false
      }
      this.exitSwitchVisible = true
    },
    saveExitSwitch() {
      this.exitSwitchSaving = true
      updateCircleExitSwitchApi(this.exitSwitchForm).then(res => {
        if (res.code === 200) {
          this.$message.success('设置已保存')
          this.exitSwitchVisible = false
          this.getList()
        } else {
          this.$message.error(res.msg || '保存失败')
        }
      }).finally(() => {
        this.exitSwitchSaving = false
      })
    },
    tabsHandleFn(tabIndex) {
      this.tabCount = tabIndex.index
      this.searchForm.pageNum = 1
      this.searchForm.auditStatus = tabIndex.index
      switch (tabIndex.index) {
        case '0':
          this.searchForm.pageNum = 1
          this.searchForm.auditStatus = ''
          break;
        default:
          this.searchForm.pageNum = 1
          this.searchForm.auditStatus = (tabIndex.index - 1)
          break;
      }
      this.getList()
    },
    editCircleStatus(row) {
      this.nowCircleData = row
      this.$refs.refCircleAudit.centerDialogVisible = true
    },
    checkSuqareFn(squareId) {
      let options = {}
      options.pageNum = this.searchForm.pageNum;
      options.pageSize = this.searchForm.pageSize;
      options.squareId = squareId;
      getSquareCircleApi(options).then((res) => {
        if (res.code == 200) {
          this.tableData = res.data.records || [];
          this.total = res.data.total;
        } else {
          this.$message.error(res.msg || "查询失败!");
        }
      }).catch(() => {
        this.$message.error(res.msg || "查询失败!");
      });
    },
    getList() {
      GetcircleListApi(this.searchForm).then(res => {
        if (res.code == 200) {
          this.tableData = res.data.records;
          this.total = res.data.total;
        } else {
          this.$message.error(res.msg || '获取列表失败');
        }
      }).cat
    },
    // 圈子翻页
    pageTurning(pageNo) {
      this.searchForm.pageNum = pageNo;
      this.getList();
    },
    handleSizeChange(size) {
      this.searchForm.pageSize = size
      this.searchForm.pageNum = 1 // 切换页大小时重置页码为1
      this.getList()
    },
    selectCircle(row) {
      this.$emit('selectCircle', row)
    },
    // 删除圈子
    deleteRow(row) {
      this.$confirm('您确定要删除此圈子吗', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }).then(() => {
        DeleteCircleApi(row.circleId).then(res => {
          if (res.code == 200) {
            this.$message({ type: 'success', message: '删除成功!' })
            this.getList();
          } else {
            this.$message.error(res.msg || '删除失败');
          }
        }).catch(() => {
          this.$message.error(res.msg || '删除失败');
        })
      }).catch(() => {
        this.$message({ type: 'info', message: '已取消删除' })
      })
    },
    expandChange(row, index) {
      if (this.expandKey[0] == row.circleId) {
        return this.expandKey = []
      }
      this.expandKey = [row.circleId]
    },
    // 编辑圈子
    handleClick(row) {
      const href = this.$router.resolve({
        path: '/newCircle',
        query: { id: row.circleId }
      }).href
      window.open(href, '_blank')
    },
    // 搜索圈子
    searchCircleCli() {
      if (this.searchType == '1') {
        if (!this.searchVal) {
          return this.$message.error('请输入广场ID')
        }
        this.checkSuqareFn(this.searchVal)
        return
      }
      if (this.searchType == '2') {
        this.searchForm.name = this.searchVal
        this.searchForm.circleId = ''
      } else {
        this.searchForm.circleId = this.searchVal
        this.searchForm.name = ''
      }
      this.getList();
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 1) {
        return 'warning-row'
      } else if (rowIndex === 3) {
        return 'success-row'
      }
      return ''
    },
    newFoundCircle() {
      this.$router.push('/newCircle')
    },
    controlFn(row, typeVal) {
      this.nowCircleId = row
      this.$store.commit('setCircleDataFn', row)

      if (typeVal == '圈子管理') {
        this.controlShow = true
      } else if (typeVal == '加入审核') {
        this.followShow = true
      } else if (typeVal == '查看帖子') {
        this.cardShow = true
      } else if (typeVal == '禁言列表') {
        this.banSpeakShow = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}

.el-form-item-edit {
  flex: 1;
  text-align: center;
  justify-content: center
}

.headerCircle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  .el-button {
    width: 100px;
    height: 40px;
  }

  .el-input {
    margin-top: 0;
  }
}

.el-select .el-input {
  width: 130px;
}

.input-with-select .el-input-group__prepend {
  background-color: #fff;
}

.exit-switch-content {
  min-height: 210px;
  padding: 4px 2px 0;
}

.exit-switch-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 72px;
  padding: 0 18px;
  margin-bottom: 14px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  background: #fafafa;
}

.exit-switch-info {
  min-width: 0;
  padding-right: 24px;
}

.exit-switch-title {
  color: #303133;
  font-size: 15px;
  line-height: 24px;
}

.exit-switch-desc {
  margin-top: 3px;
  color: #909399;
  font-size: 13px;
  line-height: 20px;
}

.exit-switch-tip {
  padding: 10px 12px;
  color: #909399;
  font-size: 13px;
  line-height: 20px;
  border-radius: 4px;
  background: #f4f4f5;
}

.exit-switch-tip .el-icon-info {
  margin-right: 5px;
  color: #409eff;
}
</style>
